<template>
  <div class="glass-background previous-project-box">
    <div class="row">
      <div class="col-4 left-image">
        <img class="previous-project-box-image" :src="Image" />
      </div>
      <div class="col-8 right-content">
        <h3 class="centered">{{Title}}</h3>
        <div class="box-body">
          <p>
            {{Text}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : [
        'Title',
        'Text',
        'Image'
    ]
};
</script>

<style>
.previous-project-box {
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  height: 200px;
  font-size: 11px;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 10px;
}

.previous-project-box:hover {
  background-color: #c4114f;
  color: white;
}

.previous-project-box-image {
  width: 100%;
  margin-top: 33px;
}

.previous-project-box h3 {
  padding: 5px;
  font-size: 16px;
}

.previous-project-box .box-body p {
  font-weight: bold;
  text-align: justify;
}

.previous-project-box .askingLawyer-icon {
  margin-top: 10px;
}

.previous-project-box .isjse-icon {
  margin-top: 35px;
}
</style>